import { type BaseProductElementProps } from "~/feature/Product/types";
import { useProductContext } from "~/feature/Product/ProductContext";
import ProductPreferredIndicator from "~/ProductDetails/components/ProductPreferredIndicator";
import classNames from "classnames";
import { type IconSize } from "~/common/components/icon/IconSize";

interface Props extends BaseProductElementProps {
  reserveSpace?: boolean;
  tooltipSide?: "left" | "right" | "bottom";
  iconSize?: IconSize;
  noMargin?: boolean;
}

export const PreferredIndicator = (props: Props) => {
  const product = useProductContext(props);
  const isPreferred = product.preferred;
  const noMargin = props.noMargin ?? false;

  if (!isPreferred && !props.reserveSpace) {
    return null;
  }

  return (
    <ProductPreferredIndicator
      className={classNames(!noMargin && "icon-margin", !isPreferred && "v-hidden", props.className)}
      side={props.tooltipSide}
      iconSize={props.iconSize}
    />
  );
};
